import React from "react"
import Context from "./src/context/Context"

export const wrapRootElement = ({ element }) => <Context>{element}</Context>
